module.exports = __webpack_public_path__ + "static/media/easy.a23a3c9b.png";